import React, { useMemo, useState } from 'react'
import { Bounds } from 'discover'
import { CategoryList, LocationsList, ProjectSelectionPageProps } from './types'
import { I18nHtml, QueryHelper } from 'shared'
import { ProjectSearch } from './project_search'
import { ProjectSelectionFilter } from './project_selection_filter'
export const ProjectSelectionPage = ({
  query: query_,
  searchCategory,
  categories: categories_,
  apiBaseUrl,
  projectSelectionUrl,
  locations: locations_,
}: ProjectSelectionPageProps): JSX.Element => {
  const initialCategoryId = useMemo(() => parseInt(searchCategory, 10), [searchCategory])
  const categories = useMemo(() => JSON.parse(categories_) as CategoryList, [categories_])
  const locations = useMemo(() => (locations_ ? (JSON.parse(locations_) as LocationsList) : []), [locations_])
  const [categoryId, setCategoryId] = useState(categories.find(({ id }) => id === initialCategoryId)?.id)
  const [query, setQuery] = useState(query_ || '')
  const params = QueryHelper.parseQuery()
  const [bounds, setBounds] = useState(Bounds.fromParams(params.bounds, params.boundsLabel))

  return (
    <div className="fundraising-events-manage-project-selection-page">
      <div className="bg-white container">
        <div className="row">
          <div className="col-md-16 offset-md-4">
            <h1 className="text-2xl desktop:text-3xl text-center desktop:mt-12">
              {i18n.t('fundraising_events.preselections.show.headline')}
            </h1>
            <div className="bpc-notice bpc-notice--alert mx-5 mt-3 mb-8">
              <I18nHtml i18nKey="fundraising_events.preselections.show.preselection_hint_html" />
            </div>
          </div>
        </div>
        <ProjectSelectionFilter
          categories={categories}
          categoryId={categoryId}
          categoryChanged={setCategoryId}
          query={query}
          queryChanged={setQuery}
          bounds={bounds}
          boundsChanged={setBounds}
          locations={locations}
        />
      </div>
      <div className="container pt-4">
        <ProjectSearch
          categoryId={categoryId}
          apiBaseUrl={apiBaseUrl}
          projectSelectionUrl={projectSelectionUrl}
          query={query}
          filter={{
            state: 'activated',
            completed: false,
            hidden_from_platform: false,
            prohibit_donations: false,
          }}
          bounds={bounds}
        />
      </div>
    </div>
  )
}
